import _ from 'lodash';
import { connect } from 'react-redux';
import { showErrors } from '../modules/general';
import { bindActionCreators } from 'redux';

const mapStateToProps = (state) => {
	const canMakeUpdates = !!_.get(state.auth.authUser, ['permissions', 'canMakeUpdates'], false);
	const isDwp = _.get(state.auth.authUser, ['userId']) === 14;
	const isExternalLogistics = _.get(state.auth.authUser, ['role']) === 'externalLogistics';
	const isExternalReporting = _.get(state.auth.authUser, ['role']) === 'externalReporting';

	return {
		authUser: state.auth.authUser,
		canMakeUpdates,
		isDwp,
		isExternalLogistics,
		isExternalReporting,
		accessToken: state.auth.accessToken, //- used on reporting page
	};
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			showErrors,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
